import { ReactElement } from "react";
import {
  IContentAreaProps,
  IDataContext, IIndicator,
  IMenuButton,
  ISelectedNode,
  IViewController,
  SchemaNodeType
} from "../../types";
import AlarmPage from "./alarmPage";
import AlarmsDashboard from "./alarmsDashboard";
import WarningIcon from "@mui/icons-material/Warning";
import DashboardIcon from "@mui/icons-material/Dashboard";

class Module implements IViewController {

  private alarmsButton: IMenuButton = {
    title: "Alarms",
    icon: <WarningIcon/>,
    color: "red",
    dataContext: {
      title: "Alarms",
      module: "alarms",
      subModule: "alarmPage"
    }
  };

  private alarmsDashboardButton: IMenuButton = {
    title: "Dashboard",
    icon: <DashboardIcon/>,
    color: "cyan",
    dataContext: {
      title: "Dashboard",
      module: "alarms",
      subModule: "alarmsDashboard"
    }
  };

  private alarmsGroupButton: IMenuButton = {
    title: "Alarms",
    icon: <WarningIcon/>,
    color: "red",
    disabled: true,
    children: [this.alarmsButton, this.alarmsDashboardButton],
    dataContext: {
      title: "Alarms",
      module: "alarms",
      subModule: "alarmsGroup"
    }
  };

  private buttons = [this.alarmsGroupButton, this.alarmsButton, this.alarmsDashboardButton];

  getModuleName(): string{
    return "alarms";
  }

  getView(dataContext: IDataContext, props: IContentAreaProps): ReactElement {
    if (dataContext.subModule === "alarmsDashboard") {
      return <AlarmsDashboard parentSize={props.parentSize} />;
    }

    return <AlarmPage />;
  }

  getButtons(node: ISelectedNode): IMenuButton[] {
    return node.type === SchemaNodeType.Zone ? [this.alarmsGroupButton] : [];
  }

  getButton(subModule: string): IMenuButton | undefined {
    return this.buttons.find(x => x.dataContext && x.dataContext.subModule === subModule);
  }

  getIndicator(dataContext: IIndicator): ReactElement | undefined {
    if (dataContext.component === "") {
      return <div />;
    }

    return undefined;
  }
}

const instance = new Module();

export default instance;
